// @flow

import CollapsibleJson from './CollapsibleJson';

export default CollapsibleJson;
